<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img
        @click="closeModal()"
        src="@/assets/icons/close.png"
        alt="close-modal-img"
      />
    </div>
    <div class="modal-title">
      Izmeni grupu
    </div>
    <div v-for="name in names" :key="name.grp_locale" class="inputs">
      <span>Naziv grupe - {{ name.grp_locale }}</span>
      <input class="single-input" type="text" v-model="name.grp_name" />
    </div>
    <div class="inputs">
      <span>Prikaz grupe:</span>
      <input
        type="checkbox"
        @change="changeVisibility($event)"
        :checked="group.grp_active"
      />
    </div>
    <div class="inputs">
      <span>Ikona</span>

      <Dropdown
        :list="icons"
        :selected="group.grp_icon"
        @changeOption="group.grp_icon = $event"
        style="min-width: 400px;"
      >
        <template #dropdown-option="{item}">
          <div style="display: flex; align-items: center; gap: 5px;">
            <Icon :icon="item" style="font-size: 20px;" />
            <span>{{ item }}</span>
          </div>
        </template>
        <template #selected-value v-if="group.grp_icon">
          <div style="display: flex; align-items: center; gap: 5px;">
            <Icon :icon="group.grp_icon" style="font-size: 20px;" />
            <span>{{ group.grp_icon }}</span>
          </div>
        </template>
      </Dropdown>

      <small>
        <a
          href="https://icon-sets.iconify.design/icon-park-solid/page-1"
          target="_blank"
        >
          Bolja pretraga:
        </a>
      </small>
    </div>
    <div class="btn-wrapper">
      <div @click="ok()" class="btn">
        ok
      </div>
      <div @click="closeModal()" class="btn">
        cancel
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import eventBus from "@/shared/eventBus.js";
import Dropdown from "../dropdown.vue";
import { Icon } from "@iconify/vue2";
import { ICONS } from "../../assets/test/icons";
export default {
  name: "editDocument",
  components: {
    Dropdown,
    Icon
  },
  props: {
    modalData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      group: {
        grp_id: this.modalData.group.grp_id,
        grp_active: this.modalData.group.grp_active,
        grp_icon: this.modalData.group.grp_icon
      },
      icons: ICONS,
      names: []
    };
  },
  created() {
    for (var i = 0; i < this.$i18n.availableLocales.length; i++) {
      let obj = {
        grp_name: "",
        grp_locale: this.$i18n.availableLocales[i]
      };
      this.names.push(obj);
    }
  },
  mounted() {
    this.getGroup();
  },
  methods: {
    ok() {
      this.group.names = this.names;
      this.modalData.ok(this.group);
      eventBus.$emit("closeModal");
    },
    closeModal() {
      eventBus.$emit("closeModal");
    },
    changeVisibility(e) {
      this.group.grp_active = e.target.checked;
    },
    getGroup() {
      api
        .getGroup(this.modalData.group.grp_id)
        .then(res => {
          for (var i = 0; i < this.names.length; i++) {
            for (var j = 0; j < res.data.data.length; j++) {
              if (this.names[i].grp_locale === res.data.data[j].grp_locale) {
                this.names[i].grp_name = res.data.data[j].grp_name;
              }
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
.modal-wrapper {
  width: 500px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;
  @import "@/assets/scss/cardStyles.scss";

  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .inputs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .single-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0px;
    }
  }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .btn {
      margin-left: 15px;
      width: 100px;
    }
  }
}
</style>
